var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "117px",
    viewBox: "0 0 18.67 21.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_2"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1FAE5",
    stroke: "#2C3B37",
    strokeLinejoin: "round",
    strokeMiterlimit: 6.35743,
    d: "M2.83 0.5l13.01 0c1.28,0 2.33,1.05 2.33,2.33l0 14.06 0 2.19c0,1.28 -1.05,2.33 -2.33,2.33l-13.01 0c-1.28,0 -2.33,-1.05 -2.33,-2.33l0 -2.92 0 -13.33c0,-1.28 1.05,-2.33 2.33,-2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10B981",
    d: "M5.59 17.39c-0.98,0 -1.27,-0.91 -1.49,-1.04 -0.15,-0.09 -0.27,-0.22 -0.95,-0.22 -0.55,0 -1.82,0.03 -2.65,0.03l0 2.92c0,1.28 1.05,2.33 2.33,2.33l13.01 0c1.28,0 2.33,-1.05 2.33,-2.33l0 -2.19c-0.89,0 -2.18,-0.01 -3.02,-0.02 -0.39,0 -0.68,-0.11 -0.78,-0.17 -0.14,-0.07 -0.47,-0.73 -0.94,-1.03 -0.39,0.33 -0.81,0.62 -1.27,0.85 -0.34,1.11 -0.53,2.74 -1.52,2.72 -0.54,-0.02 -0.85,-0.95 -1.12,-2.05 -0.06,0 -0.12,0 -0.18,0 -1.03,0 -2,-0.24 -2.85,-0.68 -0.21,0.51 -0.48,0.87 -0.9,0.88z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2072268996240"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#34D399",
    fillRule: "nonzero",
    fillOpacity: 0.501961,
    d: "M9.34 17.19c3.44,0 6.24,-2.79 6.24,-6.24 0,-3.44 -2.8,-6.24 -6.24,-6.24 -3.45,0 -6.25,2.8 -6.25,6.24 0,3.45 2.8,6.24 6.25,6.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10B981",
    d: "M12.96 15.51c-0.4,0 -0.62,0.43 -0.8,1.01 0.46,-0.23 0.88,-0.52 1.27,-0.85 -0.15,-0.09 -0.3,-0.15 -0.47,-0.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10B981",
    d: "M9.47 17.36c-0.41,-1.62 -0.71,-3.62 -1.44,-3.63 -0.98,0.01 -1.13,1.82 -1.59,2.95 0.85,0.44 1.82,0.68 2.85,0.68 0.06,0 0.12,0 0.18,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#059669",
    d: "M10.47 5.58c0.12,-0.08 0.27,-0.11 0.42,-0.07 1.85,0.59 3.3,2.04 3.88,3.89 0.08,0.25 -0.06,0.51 -0.3,0.59 -0.25,0.08 -0.51,-0.06 -0.59,-0.31 -0.42,-1.35 -1.4,-2.45 -2.67,-3.04l0 4.54c0,1.17 -0.94,2.11 -2.11,2.11 -1.16,0 -2.11,-0.94 -2.11,-2.11 0,-1.16 0.95,-2.11 2.11,-2.11 0.44,0 0.84,0.14 1.18,0.36l0 -3.47c0,-0.15 0.07,-0.29 0.19,-0.38z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0B9769",
    strokeWidth: 0.75,
    strokeMiterlimit: 1145.92,
    d: "M0.5 16.16c0.83,0 2.1,-0.03 2.65,-0.03 0.68,0 0.8,0.13 0.95,0.22 0.22,0.13 0.51,1.04 1.49,1.04 1.38,-0.01 1.07,-3.82 2.49,-3.83 1.23,0.02 1.24,5.64 2.56,5.68 1.51,0.02 1.15,-3.74 2.32,-3.73 0.74,0.02 1.22,1.11 1.41,1.19 0.1,0.06 0.39,0.17 0.78,0.17 0.84,0.01 2.13,0.02 3.02,0.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2C3B37",
    strokeLinejoin: "round",
    strokeMiterlimit: 6.35743,
    d: "M2.83 0.5l13.01 0c1.28,0 2.33,1.05 2.33,2.33l0 14.06 0 2.19c0,1.28 -1.05,2.33 -2.33,2.33l-13.01 0c-1.28,0 -2.33,-1.05 -2.33,-2.33l0 -2.92 0 -13.33c0,-1.28 1.05,-2.33 2.33,-2.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8ac4aebd02532f8be5c954a2bfdc6b75.svg";
export { ForwardRef as ReactComponent };